import React from 'react'

import './SelectLoader.scss'

export const SelectLoader = ({className}: {className?: string}) => {
	return <div className={`dm-edit-select-loader ${className || ''}`} aria-label="Loading options">
		<span></span>
		<span></span>
		<span></span>
	</div>
}
